/**
 * UAH display formatting for integer-kopeck amounts. Pure and locale-fixed so
 * server and client render identically (no Intl locale drift between runtimes).
 */
export function formatUAH(minor: number): string {
  const negative = minor < 0;
  const abs = Math.abs(minor);
  const hry = Math.floor(abs / 100);
  const kop = abs % 100;
  // Thousands separated by narrow no-break space, the Ukrainian convention.
  const grouped = String(hry).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  const kopPart = kop === 0 ? "" : `,${String(kop).padStart(2, "0")}`;
  return `${negative ? "−" : ""}${grouped}${kopPart} ₴`;
}

/** Parse a user-typed hryvnia amount ("1 200" / "1200,50") into kopecks, or null. */
export function parseUAH(input: string): number | null {
  const cleaned = input.replace(/[\s  ₴]/g, "").replace(",", ".");
  if (!cleaned || !/^\d+(\.\d{1,2})?$/.test(cleaned)) return null;
  const minor = Math.round(Number(cleaned) * 100);
  return Number.isSafeInteger(minor) ? minor : null;
}
